<template>
  <div class="coupon-list-wrap">
    <el-card class="coupon-list-body">
      <!-- 顶部按钮区域 -->
      <el-row class="common-con-btns mb10">
        <el-button size="small" type="primary" class="fresh-btn" @click="fresh">刷新</el-button>
        <el-button size="small" type="primary" class="fresh-btn" @click="exportCoupon">导出</el-button>
      </el-row>
      <!--筛选区域-->
      <el-form :inline="true" size="mini" class="demo-form-inline">
        <el-form-item label="筛选">
          <el-select v-model="selects.coupon_type" class="coupon-select">
            <el-option label="全部优惠券" :value="0"></el-option>
            <el-option label="通用优惠券" :value="1"></el-option>
            <el-option label="门店优惠卷" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="用户id" class="coupon-input" v-model="selects.ac_id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="用户手机号" class="coupon-input" v-model="selects.user_mobile"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="店铺id" class="coupon-input" v-model="selects.shop_id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="店铺手机" class="coupon-input" v-model="selects.shop_contacts_mobile"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="selects.status" class="coupon-select">
            <el-option
              v-for="(item,index) in selects.statusList"
              :key="index"
              :label="item.text"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getSelects">筛选</el-button>
          <el-button size="mini" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <!--表格区域-->
      <el-table
        class="page-wrap"
        :data="dataList"
        ref="listTable"
        header-row-class-name="table-black-header"
        style="width: 100%"
      >
        <el-table-column label="用户信息" min-width="135">
          <template slot-scope="scope">
            <div>
              <span
                @click="toUserDetail(scope.row.user_info.ac_id)"
                class="cursor underline"
                v-if="scope.row.user_info"
              >{{ scope.row.user_info.name }}</span>
            </div>
            <div
              v-if="scope.row.user_info && scope.row.user_info.mobile"
            >手机：{{ scope.row.user_info?scope.row.user_info.mobile:'' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="核销码" prop="code"></el-table-column>
        <el-table-column label="优惠券面额" min-width="100">
          <template
            slot-scope="scope"
          >￥{{ scope.row.coupon_info?scope.row.coupon_info.denomination:'' }}</template>
        </el-table-column>
        <el-table-column label="消耗积分">
          <template slot-scope="scope">{{ scope.row.coupon_info.score }}</template>
        </el-table-column>
        <el-table-column label="有效期">
          <template slot-scope="scope">
            <span>{{ scope.row.has_validity_period?scope.row.valid_day+'天':'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" min-width="185">
          <template slot-scope="scope">
            <div>兑换：{{ scope.row.generation_time }}</div>
            <div>核销：{{ scope.row.exchange_time }}</div>
          </template>
        </el-table-column>
        <el-table-column label="核销店铺" min-width="145">
          <template slot-scope="scope">
            <div v-if="scope.row.shop_info.id">
              <div>id：{{ scope.row.shop_info.id }}</div>
              <div>名称：{{ scope.row.shop_info.name }}</div>
              <div>手机：{{ scope.row.shop_info.contacts_mobile }}</div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">待使用</span>
            <span v-if="scope.row.status == 2">已使用</span>
            <span v-if="scope.row.status == 3">已失效</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.status == 1"
              @click="invalidCoupon(scope.row.id)"
            >失效</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--页码信息-->
      <div class="ftc mt10">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :total="page.total"
          :page-size="page.pageSize"
          @current-change="currentPageChange"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { couponApi } from "@/api/coupon";
export default {
  data() {
    return {
      dataList: [],
      page: {
        currentPage: 1,
        pageSize: 50,
        total: 1
      },
      selects: {
        coupon_type: 0,
        ac_id: "",
        user_mobile: "",
        shop_id: "",
        shop_contacts_mobile: "",
        status: "",
        statusList: [
          { value: "", text: "全部状态" },
          { value: 1, text: "待使用" },
          { value: 2, text: "已使用" },
          { value: 3, text: "已失效" }
        ]
      }
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.getList();
    },
    /**
     * 获取优惠券列表
     */
    getList() {
      const reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
      if (
        (this.selects.user_mobile && !reg.test(this.selects.user_mobile)) ||
        (this.selects.shop_contacts_mobile &&
          !reg.test(this.selects.shop_contacts_mobile))
      ) {
        this.$message.warning("请输入正确的手机号码！");
        return false;
      }
      const pam = {
        page: this.page.currentPage,
        per_page: this.page.pageSize,
        status: this.selects.status,
        coupon_type: this.selects.coupon_type,
        ac_id: this.selects.ac_id,
        user_mobile: this.selects.user_mobile,
        shop_id: this.selects.shop_id,
        shop_contacts_mobile: this.selects.shop_contacts_mobile
      };
      this.$EpetJs.Common.get(couponApi.getCouponListUrl, pam, {
        needLoading: true
      }).then(res => {
        this.dataList = res.data.data;
        if (res.data.meta && res.data.meta.pagination) {
          this.page.total = res.data.meta.pagination.total;
        }
      });
    },
    //刷新
    fresh() {
      this.getList();
    },
    //导出优惠券
    exportCoupon() {
      const reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
      if (
        (this.selects.user_mobile && !reg.test(this.selects.user_mobile)) ||
        (this.selects.shop_contacts_mobile &&
          !reg.test(this.selects.shop_contacts_mobile))
      ) {
        this.$message.warning("请输入正确的手机号码！");
        return false;
      }
      const pam = {
        page: this.page.currentPage,
        per_page: this.page.pageSize,
        status: this.selects.status,
        coupon_type: this.selects.coupon_type,
        ac_id: this.selects.ac_id,
        user_mobile: this.selects.user_mobile,
        shop_id: this.selects.shop_id,
        shop_contacts_mobile: this.selects.shop_contacts_mobile
      };
      this.$EpetJs.Common.get(couponApi.exportCouponUrl, pam).then(res => {
        if (res) {
          this.$message.success("操作成功，请去导出列表查看！");
        }
      });
    },
    /**
     * 失效优惠券
     */
    invalidCoupon(id) {
      this.$EpetJs.Common.confirm("是否确定修改该优惠券状态为失效？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$EpetJs.Common.patch(couponApi.invalidCouponUrl + "/" + id).then(
            res => {
              if (res) {
                this.$message.success("操作成功！");
                this.getList();
              }
            }
          );
        })
        .catch(() => {});
    },
    /**
     * 跳转用户详情
     */
    toUserDetail(acId) {
      this.$router.push("/client_user/detail/" + acId);
    },
    /**
     * 当前页改变
     * @param val
     */
    currentPageChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    /**
     * 筛选
     */
    getSelects() {
      this.page.currentPage = 1;
      this.getList();
    },
    /**
     * 重置
     */
    reset() {
      this.selects.coupon_type = 1;
      this.selects.ac_id = "";
      this.selects.user_mobile = "";
      this.selects.shop_id = "";
      this.selects.shop_contacts_mobile = "";
      this.selects.status = "";
      this.page.currentPage = 1;
      this.getList();
    }
  }
};
</script>

<style lang="less" scoped>
.coupon-list-body {
  min-height: calc(100vh - 60px);
}
.coupon-input,
.coupon-select {
  width: 110px;
}
</style>